"use client"; // This stays here
import React, { useState, useEffect } from "react";
// DO NOT import Metadata here: import type { Metadata } from "next";
import "../homepage.css"; 

const HomePageHero: React.FC = () => {
  const words = ["Design...", "Marketing...", "Development.."];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const typingSpeed = 300;

  useEffect(() => {
    let typingTimeout: ReturnType<typeof setTimeout>;

    if (!isDeleting && currentText === words[currentWordIndex]) {
      typingTimeout = setTimeout(() => {
        setIsDeleting(true);
      }, 3000);
    } else if (isDeleting && currentText === "") {
      setIsDeleting(false);
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
      typingTimeout = setTimeout(() => {
        setCurrentText("");
      }, 500);
    } else {
      const timeoutSpeed = isDeleting ? typingSpeed / 2 : typingSpeed;
      typingTimeout = setTimeout(() => {
        if (isDeleting) {
          setCurrentText((prev) => prev.slice(0, prev.length - 1));
        } else {
          setCurrentText((prev) =>
            words[currentWordIndex].slice(0, prev.length + 1)
          );
        }
      }, timeoutSpeed);
    }

    return () => clearTimeout(typingTimeout);
  }, [currentText, isDeleting]);

  return (
    <div className="pageContainer flex justify-center align-center gap-[100px] my-[35px] md:gap-[150px] flex-col">
      {/* ... rest of your JSX ... */}
       <div>
        <h1 className="text-clip overflow-hidden">
          Your one-stop <br />
          digital solution -
          <span className="sm:hidden">
            <br />
          </span>{" "}
          <span className="typing text-blue-500">{currentText}</span>
        </h1>
      </div>

    </div>
  );
};

export default HomePageHero;